/* eslint-disable */
import { produce } from "immer";
import {
  LEARN_LANDING_FILTER_FETCH_FAILURE,
  LEARN_LANDING_FILTER_FETCH_SUCCESS,
  LEARN_LANDING_FILTER_FETCH_START,
} from "../actions/types";

const learnLandingFilter = (
  state = {
    fetching: false,
    data: [],
    error: null,
  },
  action,
) => {
  switch (action.type) {
    case LEARN_LANDING_FILTER_FETCH_START:
      return produce(state, (draft) => {
        draft.fetching = true;
      });
    case LEARN_LANDING_FILTER_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.fetching = true;
        draft.data = action.data;
        draft.fetching = false;
      });
    case LEARN_LANDING_FILTER_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.fetching = false;
        draft.error = action.error;
      });
    default:
      return state;
  }
};

export default learnLandingFilter;
